/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var TransactionCommit = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TransactionCommit, _super);
    function TransactionCommit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._id = 0;
        _this.a = null;
        _this.b = null;
        _this.d = 0;
        return _this;
    }
    Object.defineProperty(TransactionCommit.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (a) {
            this._id = a;
        },
        enumerable: true,
        configurable: true
    });
    TransactionCommit.$t = markType(TransactionCommit, 'TransactionCommit');
    return TransactionCommit;
}(Base));
export { TransactionCommit };
//# sourceMappingURL=TransactionCommit.js.map
